exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".section-title {\n    text-align: left;\n\n    color: #777777;\n\n    font-size: 12px;\n    font-weight: normal;\n    line-height: 1.5;\n}\n\n.small-title {\n    display: block;\n\n    color: #777;\n\n    font-size: 12px;\n    font-weight: normal;\n}\n\n.medium-title {\n    padding-top: 2px;\n\n    color: #777777;\n\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    line-height: 1.29;\n}\n\n.title_thin-up {\n    margin-top: 0;\n}\n.title_thin-bottom {\n    margin-bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/title.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/title.css
// module chunks = 0